import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalTerms from '../../../../components/ModalTerms/ModalTerms';
import { tipoTermoUsoEnum } from '../../../../shared/util/enums/tipoTermoUsoEnum';
import TextLink from '../../../../components/ui/TextLink';
import styles from './TopBar.module.css';
import { OUVIDORIA_URL } from '../../../../shared/util/constants';

export default function TopBar() {
  const { t } = useTranslation('header');
  const [termsType, setTermsType] = useState(null);
  const close = () => setTermsType(null);

  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <TextLink
          href={OUVIDORIA_URL}
          target='_blank'
          rel='noopener noreferrer'
          className={styles.link}
          aria-label={t('TOPBAR_CONTACT')}>
          {t('TOPBAR_CONTACT')}
        </TextLink>

        <div className={styles.sep} aria-hidden='true' />

        <TextLink
          className={styles.link}
          onClick={() => setTermsType(tipoTermoUsoEnum.USUARIO)}
          aria-label={t('TOPBAR_CLIENT_TERMS')}>
          {t('TOPBAR_CLIENT_TERMS')}
        </TextLink>

        <div className={styles.sep} aria-hidden='true' />

        <TextLink
          className={styles.link}
          onClick={() => setTermsType(tipoTermoUsoEnum.FORNECEDOR)}
          aria-label={t('TOPBAR_SUPPLIER_TERMS')}>
          {t('TOPBAR_SUPPLIER_TERMS')}
        </TextLink>
      </div>

      {termsType && (
        <ModalTerms
          tipo={termsType}
          modalVisible
          handleOk={close}
          handleCancel={close}
        />
      )}
    </div>
  );
}
